import React from 'react'
import { Route, useHistory, useLocation, RouteProps } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'

const AuthRute: React.FC<RouteProps> = (props) => {
  const location = useLocation()
  const history = useHistory()
  const { token } = useSelector((state: any) => {
    return {
      token: state.user.token,
    }
  }, shallowEqual)
  if (!token && location.pathname !== '/login') {
    history.push(`/login?v=${new Date().getTime()}`)
    return null
  } else {
    return <Route {...props} />
  }
}

export default AuthRute
